module.exports = __webpack_public_path__ + "img/img-pingjia@2x.9e359568.png";